import _ from "lodash";
import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IonButton } from "@ionic/react";

import FileList from "../file-list";
import FileUploadModal from "../file-upload-modal";
import { uploadFilesClearAllProgress, deleteFile } from "../../modules";
import { EmptyPlaceholder } from "../../../common";

import styled from "styled-components";
const Panel = styled.div`
  padding: 4px 8px 4px 8px;
`;
const UploadFilesButton = styled(IonButton)`
  width: 100%;
`;
const Filter = styled.input`
  width: 100%;
  border: 1px solid rgb(170, 170, 170);
  margin: 8px 0px 8px 0px;
  border-radius: 4px;
  height: 35px;
  box-sizing: border-box;
  padding-left: 8px;
`;

const FilePanel = (props) => {
  const [filter, setFilter] = useState("");
  const [uploadFilesModalOpen, setUploadFilesModalOpen] = useState(false);

  const handleDeleteFile = (file) => {
    const values = {
      auth_token: _.get(props.credentials, "authToken"),
      file_id: _.get(file, "id"),
    };

    props.deleteFile({
      values,
      successState: {
        context: "deleteFile.FilePanel",
        onSuccess: props.onSuccessDeleteFile,
      },
    });
  };

  return (
    <Panel>
      {props.uploadAndDeleteEnabled && (
        <UploadFilesButton
          size="small"
          onClick={() => {
            setUploadFilesModalOpen(true);
            props.uploadFilesClearAllProgress();
          }}
        >
          Upload Files
        </UploadFilesButton>
      )}
      <Filter
        placeholder="Filter files..."
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value);
        }}
      />
      {props.files.length === 0 && (
        <EmptyPlaceholder itemType={"files"} filter={filter} />
      )}
      <FileList
        files={props.files}
        filter={filter}
        handleDeleteFile={handleDeleteFile}
        uploadAndDeleteEnabled={props.uploadAndDeleteEnabled}
      />
      <FileUploadModal
        isOpen={uploadFilesModalOpen}
        handleClose={() => {
          setUploadFilesModalOpen(false);
          props.onSuccessUploadFile();
        }}
        // context={props.context}
        parentId={props.parentId}
        parentContentTypeAppLabel={props.parentContentTypeAppLabel}
        parentContentTypeModel={props.parentContentTypeModel}
        uploadFilesProgress={props.uploadFilesProgress}
        uploadViewPermissionType={props.uploadViewPermissionType}
        uploadDeletePermissionType={props.uploadDeletePermissionType}
        groupId={props.groupId}
      />
    </Panel>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadFilesClearAllProgress,
      deleteFile,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(FilePanel);
